const routes = [
    {
        path: '/',
        redirect: '/main'
    },
    {
        path: '/main',
        name: 'Main',
        meta: {
            layout: 'main'
        },
        component: () => import(/* webpackChunkName: "main" */ '@/views/main.vue'),
    },
    /*
    {
        path: '/datrm',
        name: 'Datrm',
        meta: {
            layout: 'basic'
        },
        component: () => import(/!* webpackChunkName: "main" *!/ '@/views/datrm/datrm.vue'),
    },
    */
]

export default routes;
